import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TimeConstraint, TimePeriod, PeriodUnit } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { TimePeriodSelectComponent } from '../time-period-select/time-period-select.component';

@Component({
  selector: 'app-time-constraint',
  templateUrl: './time-constraint.component.html',
  styleUrls: ['./time-constraint.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimeConstraintComponent),
    multi: true
  }],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FlexLayoutModule,
    TimePeriodSelectComponent
  ]
})
export class TimeConstraintComponent implements ControlValueAccessor {

  grp = new FormGroup({
    isCurrent: new FormControl(null),
    current: new FormControl(null),
    last: new FormControl(null)
  });

  TimePeriodUnit = PeriodUnit;

  constructor() {
    this.grp.valueChanges.subscribe(_ => this.notifyFormChanged());
  }

  /// ControlValueAccessor-------------------
  @Input('value') _value: any;
  onChange: any = () => { };
  onTouched: any = () => { };
  get value(): TimeConstraint {
    return this._value;
  }
  set value(o: TimeConstraint) {

    this._value = o;

    this.grp.patchValue(o ? { ...o, isCurrent: this.getIsCurrent(o) } : {}, { emitEvent: false });

    this.onChange(o);
    this.onTouched();
  }

  getIsCurrent(o: TimeConstraint) {
    //== to check null or undefined

    if (o == null)
      return undefined;

    if (o.current == null && o.last == null)
      return undefined;

    return o.current != null;
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    this._value = this.getFormData();
    this.onChange(this._value);
    this.onTouched();
  }


  getFormData(): TimeConstraint {
    const f = this.grp.value;

    if (!f.current && !f.last)
      return undefined;

    return new TimeConstraint({
      current: f.isCurrent ? f.current : undefined,
      last: !f.isCurrent ? this.getTimePeriod(f.last) : undefined
    });
  }

  getTimePeriod(period: any): TimePeriod {
    if (!period)
      return undefined;

    var vPeriod = new TimePeriod();
    vPeriod.init(period);
    return vPeriod;
  }
}